import React from 'react';
import { useNavigate } from 'react-router-dom';
import useReviews from '../../hooks/useReviews';
import Banner from '../Bannner/Banner';
import ReviewCart from '../ReviewCart/ReviewCart';

const Home = () => {
        const [reviews] = useReviews();
        const navigate = useNavigate();

        // Handle Navigate Route:
        const handleRoute = () => {
                navigate('/reviews');
        }
        return (
                <div className="brand-bg pb-5 mt-5">
                        <Banner></Banner>
                        <h3 className="text-center text-white text-decoration-underline"><span className="brand-color">MacBook</span> Reviews</h3>
                        <div className="container">
                                <div className="row row-cols-1 row-cols-md-3 g-4 mt-5">
                                        {
                                                reviews.length === 0 ?
                                                        <img className="img-fluid w-25 rounded-3 mx-auto" src="https://trails.ca/wp-content/uploads/2020/10/loading-spinner.gif" alt="" />
                                                        :
                                                        reviews?.slice(0, 3).map(review => <ReviewCart
                                                                key={review.id}
                                                                review={review}
                                                        ></ReviewCart>)
                                        }
                                </div>
                        </div>
                        <div className="text-center mt-5">
                                <button onClick={handleRoute} className="btn brand-btn fw-bold" type="button">See All Reviews</button>
                        </div>
                </div>
        );
};

export default Home;